import React from "react";
import classnames from "classnames";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";

class ToolTip extends React.Component {
    componentWillUnmount() {
        if (
            this.tippyEl &&
            this.tippyEl.tippy &&
            this.tippyEl.tippy.destroyAll
        ) {
            this.tippyEl.tippy.destroyAll();
            this.tippyEl.tippy = null;
        }
    }
    setToolTipRef = el => {
        this.tippyEl = el;
    };
    render() {
        let title;
        if (this.props.title) {
            title = (
                <p className="help-headline">
                    Repurchase if you need an extended use license.
                </p>
            );
        }

        let content = (
            <div className="" style={{ maxWidth: "250px" }}>
                {title}
                {this.props.children}
            </div>
        );

        let target = this.props.target || (
            <span className="hover-context">
                <i className="ui_help" />
            </span>
        );

        let targetClasses = classnames(
            "nounproject-tool-tip",
            this.props.className
        );

        if (process.env.NODE_ENV == "test") {
            // Tippy does not like the JSDOM environment
            return <span className={targetClasses}>{target}</span>;
        }
        return (
            <Tooltip
                ref={this.setToolTipRef}
                className={targetClasses}
                trigger="mouseenter"
                html={content}
                interactive
                interactiveBorder={10}
                position="bottom"
                arrow
                inertia
                arrowSize="regular"
                animation="scale"
                duration="300"
                distance="16"
                delay="300"
                position={this.props.position}
                theme={this.props.theme}
                open={this.props.open}
            >
                {target}
            </Tooltip>
        );
    }
}

export default ToolTip;
